import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
const QuoteCardValue = ({ value, label, reversed }) => (<View style={styles.centered}>
    <Text TextThin-14 Secondary centered>
      {reversed ? label : value}
    </Text>
    <Text TextThin-14 Secondary centered>
      {reversed ? value : label}
    </Text>
  </View>);
const styles = StyleSheet.create({
    centered: {
        alignItems: 'center',
    },
});
export default QuoteCardValue;
